import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { ModalButtonClose } from "../../generic/common/ModalButtonClose";
import { TextLoca } from "../../generic/text/TextLoca";
import { ModalOverlay } from "../../modals/ModalOverlay";
export var ShopDialogWrapper = function (_a) {
    var children = _a.children, title = _a.title, className = _a.className, onClose = _a.onClose;
    return (React.createElement(ModalOverlay, null,
        React.createElement("div", { className: "modal" },
            React.createElement("div", { className: "offer-container" },
                React.createElement("div", { className: IdStyles.OfferHeader + " wooden-texture-background offer-header-container" },
                    title && React.createElement(TextLoca, { id: title, className: "" + IdStyles.HeadlineOne }),
                    React.createElement(ModalButtonClose, { onClick: onClose, className: "rewards-dialog__close-button" })),
                React.createElement("div", { className: className + " rewards-dialog-body-container offer-body__container" }, children)))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/ShopDialogWrapper.tsx
// module id = 2902
// module chunks = 3